import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class HRPortalSignUpDao {
  static async signUp(env: Environment, email: string, purchaserId: string) {
    // NOTE: this method should work only via VPN
    const url = hostsConfig[env].hrPortalVpn;
    const { data } = await axios.post(`${url}/aws-proxy/users`, {
      email,
      purchaserId,
    });
    return data;
  }
}
